import { GetServerSideProps } from 'next';
import { NextPage } from 'next';
import React from 'react';
import { cachedFetchSectionOrgs } from '../../api/fetchSectionOrgs';
import { SectionsOrgResponse } from '../../api/fetchSectionOrgs';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import { Companies } from '../../components/Info/Companies';
import { Info } from '../../components/Info/Info';
import { tabs } from '../../components/Info/tabs';

interface PageProps {
    orgSections: SectionsOrgResponse;
}

const CompaniesPage: NextPage<PageProps> = ({ orgSections }) => {
    useBreadcrumbs([{ title: 'О площадке' }]);

    return (
        <Info tabs={tabs} activeTab="companies">
            <Companies orgSections={orgSections} />
        </Info>
    );
};

export default CompaniesPage;

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
    res.setHeader(
        'Cache-Control',
        'public, s-maxage=10, stale-while-revalidate=59'
    );

    const orgSections = await cachedFetchSectionOrgs({
        limit: 100,
        hasLogo: true,
        minWeight: 10,
    });

    return {
        props: {
            orgSections,
        },
    };
};
